<template>
    <li
        class="DefaultNavItem"
        :class="{'is-parent' : getChildren(item).length, 'is-active' : isCurrent(item.uri)}"
        @mouseover="subnavActive = true"
        @mouseleave="subnavActive = false"
    >
        <a :href="item.url">
            {{ item.heading }}
        </a>

        <figure
            v-if="getChildren(item).length"
            class="hide--reciteme-and-up"
            @click="mobileNavActive = true"
        >
            <BaseIcon
                icon="chevron-right"
            />
        </figure>

        <transition name="fadeNav">
            <ul
                v-if="getChildren(item).length && subnavActive"
                class="DefaultNavItem__subnav hide--portable"
                @mouseleave="subnavActive = false"
            >
                <li
                    v-for="child in getChildren(item)"
                    :key="child.id"
                    class="mb-small"
                >
                    <a
                        :href="child.url"
                        class="link"
                    >
                        {{ child.title }}
                    </a>
                </li>
            </ul>
        </transition>

        <transition name="slide">
            <DefaultNav
                v-if="getChildren(item).length && mobileNavActive"
                :nav="getChildren(item)"
            >
                <li
                    class="DefaultNav__item DefaultNav__item--close text--blue is-parent"
                    @click="mobileNavActive = false"
                >
                    <a>
                        <BaseIcon
                            icon="chevron-right"
                        />
                        Back
                    </a>
                </li>
            </DefaultNav>
        </transition>
    </li>
</template>
<script>
import { EventBus } from '../scripts/event-bus'
export default {
    name: 'DefaultNavItem',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            subnavActive: false,
            mobileNavActive: false
        }
    },
    methods: {
        isCurrent(slug) {
            const uri = `/${slug}`
            return window.location.pathname === uri ? true : false
        },
        getChildren(item) {
            return item.children.filter((child) => child.hideFromNav === false);
        }
    }
}
</script>
<style lang="scss">
    .DefaultNavItem {
        position: relative;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;

        @include media-query(desk) {
            display: inline-block;
            font-size: 0.75rem;
            margin: 0 getSpacing('base');
            transition: all ease-out 0.325s;
            padding: 2.5rem 0;

            &:hover, &.is-active {
                color: $action-color;
            }

            .BaseIcon {
                display: none;
            }
        }

        @include media-query(portable) {
            position: static;
            display: block;
            background: #F5F5F5;
            border-bottom: 1px solid $border-color;

            a {
                display: block;
                padding: getSpacing('spacer');

                small {
                    text-transform: none;
                    padding-top: 0.5rem;
                    letter-spacing: 0;
                    font-weight: 500;
                    font-size: 16px;
                    display: block;
                }
            }

            figure {
                display: flex;
                cursor: pointer;
                align-items: center;
                justify-content: center;
                width: 68px;
            }

            .BaseIcon {
                font-size: 0.8rem;
                margin-right: 0.35rem;
                color: $action-color;
            }

            &.is-active {
                color: $action-color;
            }
        }

        &.is-parent {
            @include media-query(portable) {
                display: flex;
                justify-content: space-between;
            }
        }

        .DefaultNav.spaceBetween & {
            @include media-query('(min-width: 1023px) and (max-width: 1216px)') {
                margin: 0;
                display: block;
            }
        }

        .DefaultNav {
            // left: 0;
            position: absolute;
            top: 0;
        }
    }

    .DefaultNavItem--close {
        @include media-query(portable) {
            cursor: pointer;

            .BaseIcon {
                transform: rotate(180deg);
                margin-right: 1rem;
            }
        }
    }

    .slide-leave-active,
    .slide-enter-active {
        transition: 0.765s;
    }
    .slide-enter {
        transform: translate(100vw, 0);
    }
    .slide-leave-to {
        transform: translate(0vw, 100%);
    }

    .fadeNav-leave-active,
    .fadeNav-enter-active {
        transition: all .15s;
    }
    .fadeNav-enter, .fadeNav-leave-to {
        opacity: 0;
        top: 120%;
    }

    .fadeNav-enter-to, .fadeNav-leave {
        opacity: 1;
        top: 100%;
    }

    .DefaultNavItem__subnav {
        display: block;
        position: absolute;
        padding: getSpacing('medium') 1rem;
        width: 240px;
        left: 50%;
        margin-left: -120px;
        z-index: 2;
        background-color: white;
        text-align: left;
        border: 1px solid rgba(201,196,188,.3);
        border-top: 0;
        top: 100%;

        li {
            text-transform: none;

            &:last-child {
                margin-bottom: 0!important;
            }
        }
    }
</style>
